import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { leadsService } from '../services/leadsService';

/**
 * Hook para buscar interesses de um lead
 */
export const useLeadInterests = (leadId?: string) => {
  return useQuery({
    queryKey: ['lead-interests', leadId],
    queryFn: () => leadsService.getLeadInterests(leadId!),
    enabled: !!leadId,
    staleTime: 30 * 1000, // 30 seconds
  });
};

/**
 * Hook para adicionar interesses a um lead
 */
export const useAddLeadInterests = (leadId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (documentIds: string[]) => leadsService.addLeadInterests(leadId, documentIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lead-interests', leadId] });
      queryClient.invalidateQueries({ queryKey: ['leads'] });
    },
  });
};

/**
 * Hook para remover um interesse de um lead
 */
export const useRemoveLeadInterest = (leadId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (documentId: string) => leadsService.removeLeadInterest(leadId, documentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lead-interests', leadId] });
      queryClient.invalidateQueries({ queryKey: ['leads'] });
    },
  });
};

/**
 * Hook para aprovar um interesse de um lead
 */
export const useApproveLeadInterest = (leadId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (documentId: string) => leadsService.approveLeadInterest(leadId, documentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lead-interests', leadId] });
      queryClient.invalidateQueries({ queryKey: ['leads'] });
    },
  });
};
